module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-provide-variation', {
    attrs: {
      "variation": _vm.variation,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule
    },
    on: {
      "change": _vm.emitToParent
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [(Object.keys(_vm.variation.attributes).indexOf('color') !== -1 && _vm.colors.length) ? _c('form-group', {
    attrs: {
      "label": _vm.$t("color.label"),
      "columns": 3,
      "error": _vm.getError('attributes.color', _vm.variation.sku),
      "required": true
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.colors,
      "selectLabel": "Clique",
      "selectedLabel": "Selecionado",
      "placeholder": "Selecione a opção",
      "disabled": _vm.disabledInputs()
    },
    model: {
      value: (_vm.variation.attributes.color),
      callback: function($$v) {
        _vm.$set(_vm.variation.attributes, "color", $$v)
      },
      expression: "variation.attributes.color"
    }
  })], 1) : _vm._e(), _vm._v(" "), (Object.keys(_vm.variation.attributes).indexOf('size') !== -1) ? _c('form-group', {
    attrs: {
      "label": _vm.$t("size.label"),
      "columns": 3,
      "error": _vm.getError('attributes.size', _vm.variation.sku),
      "required": _vm.sizes.length > 0
    }
  }, [(_vm.sizes.length) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.attributes.size),
      expression: "variation.attributes.size"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.disabledInputs()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.variation.attributes, "size", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.sizes), function(size) {
    return _c('option', {
      domProps: {
        "value": size
      }
    }, [_vm._v(_vm._s(size))])
  })], 2) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.attributes.size),
      expression: "variation.attributes.size"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.variation.attributes.size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation.attributes, "size", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.variation.attributes).indexOf('voltage') !== -1) ? _c('form-group', {
    attrs: {
      "label": _vm.$t("voltage.label"),
      "columns": 3,
      "error": _vm.getError('attributes.voltage', _vm.variation.sku),
      "required": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.attributes['voltage']),
      expression: "variation.attributes['voltage']"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.variation.attributes['voltage'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation.attributes, 'voltage', $event.target.value)
      }
    }
  })]) : _vm._e()], 1), _vm._v(" "), (_vm.variation.gfgAttributes !== undefined && _vm.variation.gfgAttributes.length) ? _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Atributos")])])]) : _vm._e(), _vm._v(" "), (_vm.variation.gfgAttributes !== undefined && _vm.variation.gfgAttributes.length) ? _c('div', {
    staticClass: "l-row"
  }, _vm._l((_vm.variation.gfgAttributes), function(attribute, index) {
    return (_vm.variation.gfgAttributes !== undefined && _vm.variation.gfgAttributes.length) ? _c('form-group', {
      key: attribute.code,
      attrs: {
        "label": attribute.label,
        "columns": 3,
        "error": _vm.getError(attribute.code, _vm.variation.sku),
        "required": attribute.required
      }
    }, [(attribute.typeSelection === 'select') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value),
        expression: "attribute.value"
      }],
      staticClass: "form-select",
      attrs: {
        "disabled": _vm.disabledInputs()
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(attribute, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "undefined"
      }
    }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((attribute.values), function(option) {
      return _c('option', {
        domProps: {
          "value": option
        }
      }, [_vm._v(_vm._s(option))])
    })], 2) : (attribute.typeSelection === 'multiselect') ? _c('multiselect', {
      attrs: {
        "options": attribute.values,
        "multiple": true,
        "selectLabel": "Clique",
        "selectedLabel": "Selecionado",
        "placeholder": "Selecione a opção"
      },
      model: {
        value: (attribute.value),
        callback: function($$v) {
          _vm.$set(attribute, "value", $$v)
        },
        expression: "attribute.value"
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value),
        expression: "attribute.value"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text",
        "disabled": _vm.disabledInputs()
      },
      domProps: {
        "value": (attribute.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(attribute, "value", $event.target.value)
        }
      }
    })], 1) : _vm._e()
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2502b3a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/gfg/provide/Variation.vue
// module id = 2989
// module chunks = 0